export function isCoordinateValue(value) {
  const numericValue = Number(value);

  return Number.isFinite(numericValue);
}

export function hasGeolocationCoordinates(geolocation = {}) {
  return (
    isCoordinateValue(geolocation?.lat) && isCoordinateValue(geolocation?.lng)
  );
}

export function hasGeolocationSelection(geolocation = {}) {
  return (
    Boolean(geolocation?.useGeolocation) &&
    hasGeolocationCoordinates(geolocation)
  );
}

export function hasManualShippingAddress(shippingAddress = {}) {
  return Boolean(
    String(shippingAddress?.address || '').trim() &&
    String(shippingAddress?.city || '').trim() &&
    String(shippingAddress?.postalCode || '').trim() &&
    String(shippingAddress?.country || '').trim(),
  );
}

export function hasCheckoutShipping(shippingAddress = {}, geolocation = {}) {
  return (
    hasManualShippingAddress(shippingAddress) ||
    hasGeolocationSelection(geolocation)
  );
}

export function formatDetectedLocation(geolocation = {}) {
  if (!hasGeolocationCoordinates(geolocation)) {
    return '';
  }

  return `Detected location: (${Number(geolocation.lat).toFixed(5)}, ${Number(
    geolocation.lng,
  ).toFixed(5)})`;
}

export function formatShippingDestination(
  shippingAddress = {},
  geolocation = {},
) {
  if (hasGeolocationSelection(geolocation)) {
    return formatDetectedLocation(geolocation);
  }

  if (hasManualShippingAddress(shippingAddress)) {
    return [
      shippingAddress.address,
      shippingAddress.city,
      shippingAddress.postalCode,
      shippingAddress.country,
    ]
      .map((value) => String(value || '').trim())
      .filter(Boolean)
      .join(', ');
  }

  if (hasGeolocationCoordinates(geolocation)) {
    return formatDetectedLocation(geolocation);
  }

  return '';
}
